import React from 'react';
import './Footer.css';
import { FaLinkedin, FaGithub, FaEnvelope } from 'react-icons/fa';
import { SiUpwork } from 'react-icons/si';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; 2025 Yohannes Taye.</p>
        <div className="social-icons">
          <a
            href="mailto:ytaye715@gmail.com"
            className="social-icon"
            aria-label="Email"
          >
            <FaEnvelope />
          </a>
          <a
            href="https://www.linkedin.com/in/yohannes-taye-564852259"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://github.com/yohannestayez"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
            aria-label="GitHub"
          >
            <FaGithub />
          </a>
          <a
            href="https://www.upwork.com/freelancers/~010b7cef8850e1b936?mp_source=share"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
            aria-label="Upwork"
          >
            <SiUpwork />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
